<template>
    <div class="scroll-table">
        <empty-page class="no-data" tips="暂无数据" v-show="!cols.length"></empty-page>

        <template v-if="pageInstance || isStatic">
            <!-- 首行-->
            <div class="row row-start thead">
                <div class="cell col-0 main-name" >
                    <slot name="main-name">
                        {{mainName}}
                    </slot>
                    <div class="sort-nav" v-if="mainNameSort" @click="doSort(mainNameSort.prop)" >
                        <van-icon 
                            name="play" 
                            class="ascending" 
                            v-if="sortObj.sortPropName !== mainNameSort.prop || sortObj.sort !== 1" />
                        <van-icon 
                            name="play" 
                            class="descending" 
                            v-if="sortObj.sortPropName !== mainNameSort.prop || sortObj.sort !== 0"  />
                    </div>
                </div>

                <!-- 固定表头行 -->
                <div class="row-wrapper" ref="area1">
                    <div 
                        v-for="(item,index) in header" 
                        :key="index" 
                        class="cell" 
                        :style="styleArr[index]" 
                        @click="doSort(sort[index])">
                        <slot name="header" :item="item" :index="index">
                            <!-- 表头插槽 -->
                        </slot>
                        <div class="sort-nav" v-if="sort[index]" >
                            <van-icon 
                                name="play" 
                                class="ascending" 
                                v-if="sortObj.sortPropName !== sort[index] || sortObj.sort !== 1" />
                            <van-icon 
                                name="play" 
                                class="descending" 
                                v-if="sortObj.sortPropName !== sort[index] || sortObj.sort !== 0"  />
                        </div>
                    </div>
                </div>   
                
                <!-- 自适应空列 -->
                <div class="min-width cell"></div>    
            </div>

            
            <div class="tbody">  
                <van-pull-refresh class="vx-refresh" ref="vpr" :head-height="50"
                    v-model="refreshLoading" @refresh="onRefresh"   :disabled="disableRefresh"
                >          
                    <div class="scroll-area" ref="areaAll"  @touchmove="touchmove">
                        <div class="scroll-wrapper">
                            <div class="content"> 
                                <div class="left-col">
                                    <div class="col col-0" ref="area2">
                                        <div class="cell" v-for="(cell,index) in cols[0]" :key="index">
                                            <div class="van-multi-ellipsis--l2">
                                                <slot name="left-cell" :item="cell" :row="index" :col="0">
                                                    <!-- 左列格子插槽 -->
                                                </slot>
                                            </div>
                                        </div>
                                    </div>
                                </div>    
                                <!-- 内容列 -->  
                                <div class="cols-wrapper" ref="area3">
                                    <div v-for="(col,i) in cols.slice(1)" :key="i" class="col" :class="['col-' + (i + 1)]" :style="styleArr[i]">
                                        <div v-for="(cell,j) in col" :key="j" class="cell" :data-index="(i + 1) + '-' + j">
                                            <slot name="cell" :item="cell" :row="j" :col="i + 1">
                                                <!-- 内容格子插槽 -->
                                            </slot>
                                        </div>
                                    </div>                                
                                </div>  
                                <!-- 自适应空列 -->
                                <div class="col min-width"></div>            
                            </div>
                            <div class="loading-more" ref="loading" v-if="pageInstance && !pageInstance.isEnd">加载中</div>
                        </div>
                    </div>
                </van-pull-refresh>
            </div>


            <!-- 尾行合计 -->
            <div class="row row-end tfoot" v-if="sum.length">
                <div class="cell col-0 main-name">
                    <slot name="heji">汇总</slot>
                </div>

                <div class="row-wrapper"  ref="area4">
                    <div v-for="(item,index) in sum"  :key="index" class="cell" :style="styleArr[index]">
                        <slot name="sum" :item="item" :index="index">
                            <!-- 合计格子插槽 -->
                        </slot>
                    </div>
                    <!-- 自适应空列 -->
                </div>
                <div class="min-width cell"></div>  
            </div>
        </template>
    </div>
</template>

<script>
    import { getIScroll } from "@mlib/js/get-libs/index.js";
    // import emptyPage from '@teacher/components/empty-page';
    import emptyPage from '@mlib/vue/comp/empty-page/empty-page.vue';

    const defaultCfg = {
        mouseWheel: true, // 是否监听鼠标滚轮事件
        momentum: true,
        bindToWrapper: true,
        disablePointer:true,
        disableTouch:false,
        disableMouse:false,
        directionLockThreshold:0,
        bounce: false,
        scrollbars: false, // 是否显示滚动条
        fadeScrollbars: true, // 是否渐隐滚动条,关掉可以加速
        // preventDefault: true, // 是否屏蔽默认事件
        // click: true,  // 是否启用click事件
        scrollY: true, // 是否开启纵向滚动条
        scrollX: true, // 是否开启横向滚动条
        probeType: 3,
    }


    export default {
        name: "scroll-table",
        mixins: [],
        props: {
            // 要请求的接口
            api: {
                type: Function,
            },
            // 请求时需要传的参数
            params: {
                type: Object,
                default:()=>({})
            },
            // 每页请求的数量
            pageSize: {
                type: Number,
                default: 10,
            },
            //或者直接传封装的paging,不传api,params,pageSize.
            paging:{
                type:Function,
                default:null    
            },
            header:{
                type:Array,
                default:()=>[]
            },
            mainName: {
                type: Array,
                default:()=>[]
            },
            // 排序的字段
            sort:{
                type:Array,
                default:()=>[]
            },
            rows:{
                type:Array,
                default:()=>[]
            },
            mainNameSort:{
                type: Object | Boolean,
                default: false,
            },
            sum:{
                type:Array,
                default:()=>[]
            },
            disableRefresh:{
                type:Boolean,
                default:false
            },
            isStatic:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return { 
                styleArr:new Array(100).fill(null),
                refreshLoading: false,
                
                sortObj: {
                    sortPropName: '',
                    sort: 2,
                },
                threshold:80,       //load的阈值
            }
        },
        computed: { 
            pageInstance(){
                this.paging;
                this.api;
                this.params;
                this.pageSize;                
                if (this.paging){
                    return this.paging();
                } else if (this.api){
                    let paging = app.createPaging({
                            api:this.api,
                            params:this.params,     
                            pageSize:this.pageSize  
                        })
                    return paging();
                }
                return null;                
            },
            cols(){
                if (this.rows.length && this.rows[0].length){
                    let arr = new Array(this.rows[0].length).fill('').map(item=>[]);
                    this.rows.forEach((row,rowIndex)=>{
                        row.forEach((col,colIndex)=>{
                            arr[colIndex][rowIndex] = col;
                        })
                    })
                    return arr;
                } else {
                    return []
                }
            }
        },
        methods: {     
            touchmove(e){
                if (this._scroller && this._scroller.y < 0){
                    e.stopPropagation();
                }
            },
            //刷新
            onRefresh(){
                if (this.isStatic){
                    return;
                }
                this.pageInstance.refresh().then(([list,res])=>{
                    this.$emit('load',list,res);
                    this._scroller && this._scroller.scrollTo(0,0)
                }).finally(()=>{
                    this.refreshLoading = false;
                })
            },
            //加载   
            load(){
                if (this.isStatic){
                    return;
                }
                if (this.pageInstance.isBlock || this.pageInstance.isEnd){
                    return;
                }
                this.pageInstance.next().then(([list,res])=>{
                    this.$emit('load',list,res)
                })
            },
            
            scrollSync(){
                let {area1,area2,area4,loading} = this.$refs,
                    x = this._scroller.x,
                    y = this._scroller.y;
                area1.style.transform = `translate(${x}px,0) translateZ(0px)`;
                area2.style.transform = `translate(${-x}px,0) translateZ(0px)`;
                if (area4){
                    area4.style.transform = `translate(${x}px,0) translateZ(0px)`;
                }
                if (loading){
                    loading.style.transform = `translate(${-x}px,0) translateZ(0px)`;
                }

                let r = this._scroller;
                if (r.directionY && Math.abs(r.maxScrollY - r.y) < this.threshold){
                    this.load();
                }
            },

            init(){
                this._scroller = new IScroll(this.$refs.areaAll,defaultCfg);
               
                this._scroller.on('scroll',this.scrollSync)
                this._scroller.on('scrollEnd',this.scrollSync)
            },
            refreshScroller() {
                if (!this._scroller){
                    getIScroll().then(()=>this.init());
                }
                this._scroller && this._scroller.refresh();
            },
            doSort (item) {
                if (!item) return false;
                
                let  { sortPropName, sort } = this.sortObj;

                if (sortPropName === item) {
                    sort--;
                    // 小于零，恢复不排序
                    if (sort < 0) {
                        this.sortObj.sort = sort = 2;                        
                        this.$emit('cancleSort');
                        return false;
                    }
                    this.sortObj.sort = sort;
                    this.$emit('sortBy', {sortField: sortPropName, sort});

                    return false;
                } 
                
                // 使用新字段排序
                this.sortObj.sortPropName = item;
                this.sortObj.sort = 1;
                this.$emit('sortBy', {sortField: item, sort: 1}); 

            }
        },
        created() { 
            getIScroll();
        },
        mounted() { 
            this.pageInstance && this.onRefresh();
        },
        components: { 
            emptyPage
        },
        watch: { 
            cols(newval){
                if (newval.length > 0){
                    this.styleArr = new Array(100).fill(null);
                    setTimeout(()=>{
                        let area1 = Array.from(this.$refs.area1.children).map(child=>child.offsetWidth),
                            area3 = Array.from(this.$refs.area3.children).map(child=>child.offsetWidth),
                            area4 = this.$refs.area4 && Array.from(this.$refs.area4.children).map(child=>child.offsetWidth);                                                   
                        this.styleArr = area1.map((item,i)=>{
                            let max = Math.ceil(Math.max(area1[i],area3[i],area4 ? area4[i] : 0))
                            return {
                                width:max + 'px',
                                flex:'0 0 auto'
                            }
                        })
                        let {areaAll,loading} = this.$refs;
                        if (loading){
                            loading.style.width = areaAll.offsetWidth + 'px'
                        }      
                        setTimeout(() => {                            
                            this.refreshScroller();
                            this._scroller && this.scrollSync();
                        }, 20);                      
                    },20)
                }
            },
            pageInstance(newval){
                newval && this.onRefresh();
            }
        }
    }
</script>

<style scoped lang="scss">
    .scroll-table{
        $cellHeight:44px;
        $headHeight:44px;
        $footHeight:44px;
        $leftColWidth:100px;

        width:100%;
        height:100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: flex-start;
        overflow: hidden;
        position:relative;
        .thead{
            height:$headHeight;
            flex:0 0 auto;
            z-index:20;
            min-width: 100%;
        }
        .tfoot{
            height:$footHeight;
            flex: 0 0 auto;
            z-index:20;
            min-width: 100%;
        }

        .tbody{
            z-index:10;
            // flex:1 1 auto;
            flex:1;
            width:100%;
            position: relative;
        }
        .vx-refresh{
            width:100%;
            height:100%;
            position:relative;
        }

        .scroll-area{
            position:absolute;
            top:0;
            bottom:0;
            left:0;
            right:0;
            overflow: hidden;               
            .scroll-wrapper{
                position:absolute;
                left:0;
                top:0;
                min-width: 100%;
                .content{
                    display: flex;
                }
                .left-col{
                    width:$leftColWidth;
                }
                .loading-more{
                    height:50px;
                    display:flex;
                    justify-content: center;
                    align-items: center;
                }
            }         
        }        


        .main-name{
            z-index:20;
        }

        .row{
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .row-wrapper{
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .cell{
            height:44px;
            min-width:80px;
            padding:5px;
            flex-shrink: 0;
        }
        .min-width{
            flex: 1 1 auto !important;
            min-width:0 !important;
            padding:0 !important;
        }

        .col{
            display: flex;
            flex-direction: column;
            align-items: stretch;
        }
        .col-0{
            width:$leftColWidth;
            flex:0 0 auto;
            .cell{
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }
        }
        .cols-wrapper{
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
        }
        .sort-nav{
            margin-left: calc(var(--gap) * 4);
            display: flex;
            flex-direction: column;
            .ascending{
                transform: rotateZ(-90deg);
            }
            .descending{
                transform: rotateZ(90deg);
            }
            >i:nth-child(2){                
                margin-top: calc(var(--gap) * -4);
            }
        }

    }
    
</style>